import { render, staticRenderFns } from "./resource-guarantee.vue?vue&type=template&id=1d99540d&scoped=true"
import script from "./resource-guarantee.vue?vue&type=script&lang=js"
export * from "./resource-guarantee.vue?vue&type=script&lang=js"
import style0 from "./resource-guarantee.vue?vue&type=style&index=0&id=1d99540d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99540d",
  null
  
)

export default component.exports